module.exports = __webpack_public_path__ + "static/media/contact-banner.8c37492d.jpg";